var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CarrosselWizard',{attrs:{"tipo-conteudo":"PRODUCT_CATEGORY","product-editor-mode":true,"carousel-type-variant":"type1"}})}
var staticRenderFns = []

export { render, staticRenderFns }